var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category",
    transform: "translate(0.495 -0.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Category-2",
    "data-name": "Category",
    d: "M12.673,18a2.294,2.294,0,0,1-2.287-2.3V12.628a2.289,2.289,0,0,1,2.287-2.305h3.042A2.294,2.294,0,0,1,18,12.628V15.7A2.3,2.3,0,0,1,15.714,18ZM2.286,18A2.3,2.3,0,0,1,0,15.7V12.628a2.294,2.294,0,0,1,2.286-2.305H5.328a2.289,2.289,0,0,1,2.286,2.305V15.7A2.294,2.294,0,0,1,5.328,18ZM12.673,7.677a2.288,2.288,0,0,1-2.287-2.3V2.305A2.294,2.294,0,0,1,12.673,0h3.042A2.3,2.3,0,0,1,18,2.305V5.373a2.293,2.293,0,0,1-2.286,2.3Zm-10.387,0A2.294,2.294,0,0,1,0,5.373V2.305A2.3,2.3,0,0,1,2.286,0H5.328A2.294,2.294,0,0,1,7.614,2.305V5.373a2.288,2.288,0,0,1-2.286,2.3Z",
    transform: "translate(-0.495 0.186)",
    fill: "#faa84f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.027b8ee33a038d6743e3175e50ca05b5.svg";
export { ForwardRef as ReactComponent };